import { render, staticRenderFns } from "./Tachogram.vue?vue&type=template&id=242e854e&scoped=true"
import script from "./Tachogram.vue?vue&type=script&lang=js"
export * from "./Tachogram.vue?vue&type=script&lang=js"
import style0 from "./Tachogram.vue?vue&type=style&index=0&id=242e854e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242e854e",
  null
  
)

export default component.exports